export default {
  scales: {
    xAxes: [
      {
        display: true, gridLines: { zeroLineColor: "#ededed", zeroLineWidth: 2, z: 4 }, ticks: {
          beginAtZero: true
        }
      }],
    yAxes: [{
      display: true, gridLines: { zeroLineColor: "#ededed", zeroLineWidth: 2, z: 4 }, ticks: {
        beginAtZero: true
      }
    }]
  }
}
